/**
 * Main app module.
 * @module src/App
 */

import React from 'react';
import {
    BrowserRouter,
    Redirect,
    Route,
    Switch,
} from 'react-router-dom';
import AsyncComponent from 'src/AsyncComponent';
import { routeConfigFlat } from 'src/routeConfig';

import Header from 'src/App/Header';
import Footer from 'src/App/Footer';

import * as styles from './index.less';

const routes = routeConfigFlat.reduce((rs, config) => {
    const { path, component } = config;
    const isRoot = (path === '/');

    rs.push((
        <Route
            key={path}
            path={path}
            exact={isRoot}
            strict
            component={component}
        />
    ));

    if (!isRoot && path.endsWith('/')) {
        // Redirect from `/<path>` to `/<path>/`.
        const from = path.slice(0, -1);
        rs.push((
            <Redirect
                key={from}
                from={from}
                exact
                strict
                to={path}
            />
        ));
    }

    return rs;
}, []);

/**
 * Asynchronous default route ("404 Not Found") component.
 * @returns {React.ReactElement} The app's elements.
 */
function NotFound() {
    return (
        <AsyncComponent getModule={() => import('src/NotFound')} />
    );
}

/**
 * React component for the entire app.
 * @returns {React.ReactElement} The app's elements.
 */
export default function App() {
    return (
        <BrowserRouter basename={__webpack_public_path__}>
            <Header />
            <main className={styles.container}>
                <Switch>
                    { routes }
                    <Route component={NotFound} />
                </Switch>
            </main>
            <Footer />
        </BrowserRouter>
    );
}
